import Vue from 'vue';

export class Comandos{

    /**
     *
     * @param idRastreador
     * @return {Promise}
     */
    static limparPosicoesAntigas(idRastreador){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/limpar-posicoes/' + idRastreador, {id_rastreador: idRastreador})
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static free(idRastreador, comando){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/free', {
                    id_rastreador: idRastreador,
                    comando: comando
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static freeAll(idRastreador, comando){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/free/all', {
                    id_rastreador: idRastreador,
                    comando: comando
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @return {Promise}
     */
    static reset(idRastreador){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/reset', {id_rastreador: idRastreador})
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static habilitarHodometro(idRastreador, enable = true){
        return Vue.http.post('comando/hodometro/enable', {
            id_rastreador: idRastreador,
            enable: enable
        });
    }

    static habilitarHodometroMetragem(idRastreador, valor = 1){
        return Vue.http.post('comando/hodometro/metragem', {
            id_rastreador: idRastreador,
            valor: valor
        });
    }

    static sendAngle(idRastreador, valor = 45){
        return Vue.http.post('comando/angulo', {
            id_rastreador: idRastreador,
            valor: valor
        });
    }

    /**
     *
     * @param idRastreador
     * @param enable
     * @return {Promise}
     */
    static bloqueioImediato(idRastreador, enable){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/bloqueio-imediato', {
                    id_rastreador: idRastreador,
                    enable: enable
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static habiliarEconomia(idRastreador, enable){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('configuracao-concox/habilitar-economia', {
                    id_rastreador: idRastreador,
                    enable: enable
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static habilitarSleep(idRastreador, enable){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('configuracao-concox/sleep', {
                    id_rastreador: idRastreador,
                    enable: enable
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static tempo2Sleep(idRastreador, value){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('configuracao-concox/tempo-sleep', {
                    id_rastreador: idRastreador,
                    value: value
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    static habiliarAlertaVibracao(idRastreador, enable){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('configuracao-concox/habilitar-alerta-vibracao', {
                    id_rastreador: idRastreador,
                    enable: enable
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @param timezone
     * @return {Promise}
     */
    static setTimezone(idRastreador, timezone){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/timezone', {
                    id_rastreador: idRastreador,
                    timezone: timezone
                })
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @return {Promise}
     */
    static resetGps(idRastreador){
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/reset-gps', {id_rastreador: idRastreador})
                .then(() => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @param valor
     * @return {Promise<any>}
     */
    static ajustarHodometro(idRastreador, valor){
        let body = {
            id_rastreador: idRastreador,
            valor: valor
        };
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/hodometro', body)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @param valor
     * @return {Promise<any>}
     */
    static ajustarHorimetro(idRastreador, valor){
        let body = {
            id_rastreador: idRastreador,
            valor: valor
        };
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/horimetro', body)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @param output1
     * @return {Promise<any>}
     */
    static output1(idRastreador, output1){
        let body = {
            id_rastreador: idRastreador,
            status: output1
        };
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/output1', body)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idRastreador
     * @param output2
     * @return {Promise<any>}
     */
    static output2(idRastreador, output2){
        let body = {
            id_rastreador: idRastreador,
            status: output2
        };
        return new Promise((resolve, reject) => {
            Vue
                .http
                .post('comando/output2', body)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param id_rastreador
     * @return {Promise}
     */
    static solicitarConfiguracao(id_rastreador){
        return new Promise((ok, fail) => {
            Vue
                .http
                .post('comando/solicitar-configuracao/'+ id_rastreador)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    static ignVirtual(idRastreador, enable){
        return new Promise((ok, fail) => {
            Vue
                .http
                .post('comando/ign-virtual', {
                    id_rastreador: idRastreador,
                    enable: enable
                })
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }



    /**
     *
     * @param id_rastreador
     * @return {Promise}
     */
    static solicitarPosicao(id_rastreador){
        return new Promise((ok, fail) => {
            Vue
                .http
                .post('comando/solicitar_posicao/'+ id_rastreador)
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @return {Promise<any>}
     */
    static solicitarConfiguracaoTodos(){
        return new Promise((ok, fail) => {
            Vue
                .http
                .post('comando/solicitar-configuracao')
                .then(() => ok())
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id_rastreador
     * @return {Promise}
     */
    static last(id_rastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('comandos/by-rastreador/'+ id_rastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    /**
     *
     * @param id
     * @return {Promise}
     */
    static excluir(id){
        return new Promise((ok, fail) => {
            Vue.http.delete('comandos/one/'+ id)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

}
